export const isUserLoginFunc = () => {
  const myRTP = JSON.parse(localStorage.getItem("MyRTP"));
  if (myRTP && myRTP.hasOwnProperty("SubjectID")) {
    return myRTP.SubjectID;
  } else return false;
};

export const toObjFilterConverter = (obj) => {
  const arrayData = [];

  //quickSearch
  // if (obj?.quickSearch &&
  //   obj?.quickSearch[0] &&
  //   obj?.quickSearch[0]?.cities) {
  //   arrayData.push({
  //     column: "City",
  //     operator: "eq",
  //     value: obj?.quickSearch[0]?.cities[0]?.City,
  //   });
  // }

  // if (obj?.quickSearch &&
  //   obj?.quickSearch[0] &&
  //   obj?.quickSearch[0]?.postal) {
  //   arrayData.push({
  //     column: "PostalCode",
  //     operator: "in",
  //     value: [obj?.quickSearch[0]?.postal[0]?.value]
  //   });
  // }
  // mls num

  if (obj?.subdomain) {
    arrayData.push({
      column: "subdomain",
      operator: "eq",
      value: obj.subdomain,
    });
  }

  if (obj?.mlsNum) {
    arrayData.push({
      column: "MlsNum",
      operator: "eq",
      value: +obj?.mlsNum,
    });
  }

  //propertyType propertySubType

  if (obj?.propertyType && obj?.propertyType[0]) {
    arrayData.push({
      column: "PropertyType",
      operator: "eq",
      value: obj?.propertyType[0],
    });
  }

  if (obj.propertySubType && obj.propertySubType[0]) {
    const propSubTypes = obj.propertySubType.map((sub) => sub);
    arrayData.push({
      column: "PropertySubType",
      operator: "in",
      value: [...propSubTypes],
    });
  }

  //Filter location
  if (
    obj?.region &&
    !obj?.metro &&
    !obj?.country?.length > 0 &&
    !obj?.city?.length > 0 &&
    !obj?.postal?.length > 0
  ) {
    // const temp = obj?.metro.map((c) => c.value);
    arrayData.push({
      column: "Region",
      operator: "eq",
      value: obj?.region,
    });
  }

  if (
    obj?.metro &&
    !obj?.county?.length > 0 &&
    !obj?.city?.length > 0 &&
    !obj?.postal?.length > 0
  ) {
    // const temp = obj?.metro.map((c) => c.value);
    arrayData.push({
      column: "Metro",
      operator: "eq",
      value: obj?.metro,
    });
  }

  if (obj?.county && !obj?.city?.length > 0 && !obj?.postal?.length > 0) {
    const temp = obj?.county.map((c) => c);
    arrayData.push({
      column: "CountyOrParish",
      operator: "in",
      value: temp,
    });
  }

  if (obj?.city && !obj?.postal?.length > 0) {
    const temp = obj?.city.map((c) => c);
    arrayData.push({
      column: "City",
      operator: "in",
      value: temp,
    });
  }

  if (obj?.postal && obj?.postal[0] !== "" && obj?.postal?.length > 0) {
    const temp = obj?.postal.map((c) => c);
    arrayData.push({
      column: "PostalCode",
      operator: "in",
      value: temp,
    });
  }

  //Home Features
  if (obj?.minPrice) {
    arrayData.push({
      column: "ListPrice",
      operator: "min",
      value: +obj.minPrice,
    });
  }
  if (obj?.maxPrice) {
    arrayData.push({
      column: "ListPrice",
      operator: "max",
      value: +obj.maxPrice,
    });
  }

  if (obj?.minBath) {
    arrayData.push({
      column: "BathroomsFull",
      operator: "min",
      value: +obj.minBath,
    });
  }

  if (obj?.maxBath) {
    arrayData.push({
      column: "BathroomsFull",
      operator: "max",
      value: +obj.maxBath,
    });
  }

  if (obj?.minBeds) {
    arrayData.push({
      column: "BedroomsTotal",
      operator: "min",
      value: +obj.minBeds,
    });
  }
  if (obj?.maxBeds) {
    arrayData.push({
      column: "BedroomsTotal",
      operator: "max",
      value: +obj.maxBeds,
    });
  }

  if (obj?.minLevels) {
    arrayData.push({
      column: "Stories",
      operator: "min",
      value: +obj.minLevels,
    });
  }

  if (obj?.maxLevels) {
    arrayData.push({
      column: "Stories",
      operator: "max",
      value: +obj.maxLevels,
    });
  }

  if (obj?.minSizeAcres) {
    arrayData.push({
      column: "LotSizeAcres",
      operator: "min",
      value: +obj.minSizeAcres,
    });
  }

  if (obj?.maxSizeAcres) {
    arrayData.push({
      column: "LotSizeAcres",
      operator: "max",
      value: +obj.maxSizeAcres,
    });
  }

  if (obj?.minGarageSpaces) {
    arrayData.push({
      column: "GarageSpaces",
      operator: "min",
      value: +obj.minGarageSpaces,
    });
  }
  if (obj?.maxGarageSpaces) {
    arrayData.push({
      column: "GarageSpaces",
      operator: "max",
      value: +obj.maxGarageSpaces,
    });
  }

  if (obj?.minYearBuilt) {
    arrayData.push({
      column: "YearBuilt",
      operator: "min",
      value: +obj.minYearBuilt,
    });
  }

  if (obj?.maxYearBuilt) {
    arrayData.push({
      column: "YearBuilt",
      operator: "max",
      value: +obj.maxYearBuilt,
    });
  }

  if (obj?.minSqft) {
    arrayData.push({
      column: "AboveGradeFinishedArea",
      operator: "min",
      value: +obj.minSqft,
    });
  }

  if (obj?.maxSqft) {
    arrayData.push({
      column: "AboveGradeFinishedArea",
      operator: "max",
      value: +obj.maxSqft,
    });
  }

  if (obj?.mainLevelPrimary) {
    arrayData.push({
      column: "MainLevelPrimary",
      operator: "eq",
      value: obj.mainLevelPrimary, //true or false
    });
  }

  if (obj?.fireplace) {
    arrayData.push({
      column: "FireplaceYN",
      operator: "eq",
      value: obj.fireplace, //true or false
    });
  }

  if (obj?.accessibilityFeatures) {
    arrayData.push({
      column: "AccessibilityFeatures",
      operator: "eq",
      value: obj?.accessibilityFeatures, //true or false
    });
  }

  //Status only
  const active = obj?.status?.active;
  const activeUnderContract = obj?.status?.activeUnderContract;
  const closed = obj?.status?.closed;
  const comingSoon = obj?.status?.comingSoon;
  const pending = obj?.status?.pending;
  if (active || activeUnderContract || closed || comingSoon || pending) {
    const arrValue = [];
    if (active === "true") arrValue.push("Active");
    if (activeUnderContract === "true") arrValue.push("ActiveUnderContract");
    if (closed === "true") arrValue.push("Closed");
    if (comingSoon === "true") arrValue.push("ComingSoon");
    if (pending === "true") arrValue.push("Pending");
    if (arrValue.length > 0)
      arrayData.push({
        column: "MlsStatus",
        operator: "in",
        value: arrValue,
      });
  }
  //TimeFrame only
  const oneDay = obj?.timeFrame?.oneDay;
  const sevenDay = obj?.timeFrame?.sevenDay;
  const thirtyDay = obj?.timeFrame?.thirtyDay;
  if (oneDay || sevenDay || thirtyDay) {
    let value = null;
    if (oneDay) value = 1;
    if (sevenDay) value = 7;
    if (thirtyDay) value = 30;
    arrayData.push({
      column: "DOM",
      operator: "le",
      value: +value,
    });
  }
  //Show only
  if (obj?.showOnly?.openHouses === "true") {
    arrayData.push({
      column: "oh",
      operator: "eq",
      value: obj.showOnly.openHouses,
    });
  }

  if (obj?.showOnly?.ourListings === "true") {
    arrayData.push({
      column: "rtlist",
      operator: "eq",
      value: obj.showOnly.ourListings,
    });
  }

  if (arrayData.length === 0) return null;
  return arrayData;
};

export const getCentralOffset = ()=>{
  const date = new Date();
  const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Chicago",
      timeZoneName: "short",
  });

  // Extract the CST/CDT abbreviation
  const timeZoneAbbreviation = formatter.formatToParts(date).find(part => part.type === "timeZoneName").value;

  // Return the correct UTC offset based on CST/CDT
  return timeZoneAbbreviation === "CDT" ? "-05:00" : "-06:00";
}

export const formatOpenHouseDate = (openHouse, type="full") => {
    // Validate required properties (optional)
    const requiredProperties = ["OpenHouseDate"];
    for (const prop of requiredProperties) {
      if (openHouse[prop] === null || typeof openHouse[prop] === 'undefined') {
        //throw new Error(`Missing required property: ${prop}`);
            return "n/a"
        }
    }

    // Parse the date and time strings
    const options = { 
      timeZone: 'America/Chicago', 
      hour12: true, 
      month: 'numeric', 
      day: 'numeric', 
      year: 'numeric', 
      hour: 'numeric', 
      minute: '2-digit' 
  };

  // Convert OpenHouseDate to America/Chicago time
  //console.log('openHouse.OpenHouseDate',openHouse.OpenHouseDate, openHouse.OpenHouseStartTime);
  const startDateTexas = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', month: 'numeric', day: 'numeric', year: 'numeric' })
                          .format(new Date(openHouse.OpenHouseStartTime));

  // Convert Start & End Times to America/Chicago
  const startTimeTexas = new Intl.DateTimeFormat('en-US', { ...options, year: undefined, month: undefined, day: undefined }).format(new Date(openHouse.OpenHouseStartTime));
  const endTimeTexas = new Intl.DateTimeFormat('en-US', { ...options, year: undefined, month: undefined, day: undefined }).format(new Date(openHouse.OpenHouseEndTime));

  // Construct final string
  if(type === "date") {
    return `${startDateTexas}`;
  }
  else if(type === "time") {
    return `${startTimeTexas} - ${endTimeTexas}`;
  }
  else {
    return `${startDateTexas} ${startTimeTexas} - ${endTimeTexas}`;
  }
  
}

export const MachineDateToUSDate = (dateString, type="full") => {
  try {
    // Parse the date and time strings
    const options = { timeZone: 'America/Chicago', month: 'numeric', day: 'numeric', year: 'numeric' };
    const startDateTexas = new Intl.DateTimeFormat('en-US', options).format(new Date(dateString));
    // Construct final string
      return startDateTexas;
  } catch (error) {
    
  }
  return dateString;

}

export const formatICSDate = (utcDateString) => {
  const date = new Date(utcDateString);

  // Convert to America/Chicago (Central Time)
  const options = { 
      timeZone: 'America/Chicago', 
      year: 'numeric', 
      month: '2-digit', 
      day: '2-digit', 
      hour: '2-digit', 
      minute: '2-digit', 
      hour12: false 
  };

  // Extract Date Parts Directly
  const chicagoDate = new Intl.DateTimeFormat('en-US', options).formatToParts(date);

  // Create a mapping for each part (year, month, day, hour, minute)
  let dateParts = {};
  chicagoDate.forEach(({ type, value }) => {
      dateParts[type] = value;
  });

  // Ensure proper formatting as YYYYMMDDTHH:ii
  return `${dateParts.year}${dateParts.month}${dateParts.day}T${dateParts.hour}${dateParts.minute}00`;
};

export const addToCalendar = async (listing,openhouse) => {
      try {
        // Generate ICS content
        const csContent = 
`BEGIN:VCALENDAR
VERSION:2.0
PRODID:Realty Texas LLC
METHOD:PUBLISH
BEGIN:VEVENT
UID:${crypto.randomUUID()}
DTSTAMP;VALUE=DATE-TIME:${formatICSDate(new Date().toISOString())}
DTSTART;VALUE=DATE-TIME:${formatICSDate(openhouse.OpenHouseStartTime)}
DTEND;VALUE=DATE-TIME:${formatICSDate(openhouse.OpenHouseEndTime)}
SUMMARY:Open House: ${listing?.Address}, ${listing?.City}, ${listing?.StateOrProvince} ${listing?.PostalCode}
DESCRIPTION:Web page: https://www.realtytexas.com${listing?.url}
LOCATION:${listing?.Address?.trim()}, ${listing?.City}, ${listing?.StateOrProvince} ${listing?.PostalCode}
GEO:${listing?.Latitude};${listing?.Longitude}
END:VEVENT
END:VCALENDAR

      `;
  
    //console.log(csContent); // Debugging
    // Convert Address to Slug Format for Filename
    const slug = listing?.Address?.toLowerCase()?.trim().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
    const fileName = `${slug}-openhouse.ics`;

    // Create Blob for Download
    const blob = new Blob([csContent], { type: 'text/calendar' });
    const url = window.URL.createObjectURL(blob);

    // Create Download Link
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  } catch (error) {
    
  }
}